import React, { useEffect, useRef } from 'react';
import NewHeroSectionStyle from './style';
import { Container, Text } from '@weareconceptstudio/core';
import CustomImage from '@/components/Image';
import TitleAnim from '@/animation';

//! Lazy load GSAP
let gsap = null;
const loadGSAP = async () => {
	if (!gsap) {
		const gsapModule = await import('gsap');
		gsap = gsapModule.default || gsapModule;
	}
	return gsap;
};

const NewHeroSection = ({ title, description, desktop_image, mobile_image }) => {
	const titleRef = useRef(null);
	const descriptionRef = useRef(null);
	const bottomSvgRef = useRef(null);
	const pathRef = useRef(null);

	useEffect(() => {
		loadGSAP().then((gsap) => {
			if (pathRef.current) {
				gsap.fromTo(
					pathRef.current,
					{
						attr: {
							d: 'M0 0.0753174C0 0.0753174 778.909 1.90587 1280 2.07532C1783.04 2.24542 2560 0.0753174 2560 0.0753174V136.075H1280H0V0.0753174Z',
						},
					},
					{
						attr: {
							d: 'M0 0.0753098C0 0.0753098 778.909 123.906 1280 124.075C1783.04 124.245 2560 0.0753098 2560 0.0753098V136.075H1280H0V0.0753098Z',
						},
						duration: 1,
						delay: 0.5,
						ease: 'power2.inOut',
					}
				);
			}
		});
	}, []);

	return (
		<NewHeroSectionStyle
			id={'hero-section'}
			className='hero-section'
		>
			<TitleAnim
				animRef={titleRef}
				configAnim={{ delay: 0.3 }}
			/>

			<TitleAnim
				animRef={descriptionRef}
				configAnim={{ delay: 0.6 }}
				animType='subtitle'
			/>

			<div className='hero-inner-section'>
				<Container row>
					<div className='left-block col-3 col-m-12' />
					<div className='center-block col-6 col-m-12'>
						<div className='center-block-inner'>
							<Text
								tag={'h1'}
								ref={titleRef}
								className='h2 white-1000 montserrat-400 align-center title opacity-zero'
							>
								{title}
							</Text>
						</div>
					</div>
					<div className='right-block col-3 col-m-12' />

					<div className='left-block col-2 col-dl-3 col-dm-2 col-dx-1 col-m-12' />
					<div className='center-block col-8 col-dl-6 col-dm-8 col-dx-10 col-m-12'>
						<div className='center-block-inner'>
							<Text
								ref={descriptionRef}
								className='p p1 white-1000 montserrat-400 align-center description opacity-zero'
							>
								{description}
							</Text>
						</div>
					</div>
					<div className='right-block col-2 col-dl-3 col-dm-2 col-dx-1 col-m-12' />
				</Container>
			</div>

			<div className='image-block'>
				<div className='image-inner-block'>
					<CustomImage
						priority
						double={[desktop_image, mobile_image]}
					/>
				</div>
			</div>

			{/* <svg
				ref={bottomSvgRef}
				xmlns='http://www.w3.org/2000/svg'
				width='2560'
				height='137'
				viewBox='0 0 2560 137'
				fill='none'
				className='svg-border'
			>
				<path
					ref={pathRef}
					d='M0 0.07531C0 0.07531 778.909 -0.0941378 1280 0.0753098C1783.04 0.245415 2560 0.07531 2560 0.07531V136.075H1280H0V0.07531Z'
					fill='white'
				/>
			</svg> */}

			<svg
				ref={bottomSvgRef}
				xmlns='http://www.w3.org/2000/svg'
				viewBox='0 0 2560 137'
				fill='green'
				className='svg-border'
			>
				<path
					ref={pathRef}
					d='M0 0.0753174C0 0.0753174 778.909 1.90587 1280 2.07532C1783.04 2.24542 2560 0.0753174 2560 0.0753174V136.075H1280H0V0.0753174Z'
					fill='white'
				/>
			</svg>
		</NewHeroSectionStyle>
	);
};

export default NewHeroSection;
